import { CheckCircle2, Award, Truck, Handshake } from "lucide-react";
import { IMAGES } from "../../data/site";

const POINTS = [
    {
        icon: Truck,
        title: "1 → 13 trucks",
        body: "Our founder spent 7 years at Green Attic Insulation, helping scale the company from a single truck to a 13-truck operation while running the field side day-to-day.",
    },
    {
        icon: Award,
        title: "50+ five-star reviews",
        body: "Track record built on Titanium Insulation’s book of business — 50+ verified five-star reviews in just 18 months.",
    },
    {
        icon: Handshake,
        title: "NICOR rebate partner",
        body: "We file the rebate paperwork for you. Most homeowners knock 20–60% off their attic project before NICOR’s incentive checks even arrive.",
    },
    {
        icon: CheckCircle2,
        title: "Built for both audiences",
        body: "Homeowners get hand-holding from quote → rebate. Contractors get a sub-crew that shows up clean, on-time, and inspector-ready.",
    },
];

export const WhyChooseUs = () => {
    return (
        <section
            id="why"
            data-testid="why-choose-us-section"
            className="bg-moss text-bone relative overflow-hidden"
        >
            <div className="absolute inset-0 grain pointer-events-none" />
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 relative grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">
                {/* Left: Text */}
                <div className="lg:col-span-7 reveal">
                    <div className="text-xs tracking-[0.22em] uppercase font-bold text-ember mb-6">
                        <span className="h-px w-10 bg-ember inline-block align-middle mr-3" />
                        Why HAZ Insulation
                    </div>
                    <h2 className="font-heading text-3xl sm:text-4xl lg:text-6xl font-bold leading-[1.02] tracking-tight">
                        We&apos;re not a referral chain.
                        <br />
                        <span className="text-ember">We&apos;re the crew.</span>
                    </h2>
                    <p className="mt-6 text-bone/85 max-w-2xl leading-relaxed text-lg">
                        50 years of combined experience in attics, walls, and crawl spaces — across
                        retrofits, new construction, and contractor work across Chicagoland.
                    </p>

                    <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-10">
                        {POINTS.map((p) => {
                            const Icon = p.icon;
                            return (
                                <div
                                    key={p.title}
                                    data-testid={`why-point-${p.title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
                                    className="reveal"
                                >
                                    <Icon
                                        size={28}
                                        strokeWidth={1.5}
                                        className="text-ember mb-4"
                                    />
                                    <h3 className="font-heading text-xl font-bold mb-2">
                                        {p.title}
                                    </h3>
                                    <p className="text-bone/75 text-sm leading-relaxed">
                                        {p.body}
                                    </p>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Right: Image stack */}
                <div className="lg:col-span-5 reveal hidden md:block">
                    <div className="relative">
                        <img
                            src={IMAGES.contractor}
                            alt="Insulation contractor at work"
                            className="w-full aspect-[4/5] object-cover"
                        />
                        <div className="absolute -bottom-10 -left-10 bg-bone text-ink p-7 max-w-xs shadow-2xl">
                            <div className="text-xs uppercase tracking-[0.2em] text-moss font-bold mb-2">
                                Official Partner
                            </div>
                            <div className="font-heading text-3xl font-extrabold leading-none">
                                NICOR
                            </div>
                            <div className="text-sm text-muted_ink mt-2">
                                Energy-efficiency rebate program — we file the paperwork for you.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
